import { type TJsonQueryOptionalKeys, getOfferTypeFromJsonQuery, getTermValue, isSuburban } from '@/packages/JsonQuery';

import { type ITagGroupConfig, type TagWithModifierArguments } from '../types';

export const hasElectricity: ITagGroupConfig = {
  get({ jsonQuery }) {
    const offerType = getOfferTypeFromJsonQuery(jsonQuery);
    const suburban = isSuburban(offerType);
    const key: TJsonQueryOptionalKeys = suburban ? 'electricity' : 'has_electricity';
    const value = getTermValue(key)(jsonQuery);
    if (!value) {
      return null;
    }

    return [
      {
        group: 'hasElectricity',
        text: 'Есть электричество',
        data: [key],
      },
    ];
  },
  delete({ onChange }, tag: TagWithModifierArguments) {
    onChange({
      action: 'resetTerms',
      arguments: [tag.data],
    });
  },
};
